import { Component, effect, inject, input, Type, ViewContainerRef } from '@angular/core';
import { ModalIdWB } from '@tdwb/core';

import { ModalNotificationFractionalTradingComponent } from './whats-new/fractional-trading/modal-notification-fractional-trading.component';
import { ModalNotificationRecurringTransfersComponent } from './whats-new/recurring-transfers/modal-notification-recurring-transfers.component';
import { ModalNotificationFhsaAccountComponent } from './whats-new/fhsa-account/modal-notification-fhsa-account.component';
import { ModalNotificationFhsaRecurringComponent } from './whats-new/fhsa-recurring/modal-notification-fhsa-recurring.component';
import { ModalNotificationTransactionHistoryComponent } from './whats-new/transaction-history/modal-notification-transaction-history.component';
import { ModalNotificationFullyPaidLendingComponent } from './whats-new/fully-paid-lending/modal-notification-fully-paid-lending.component';
import { ModalNotificationDripsComponent } from './whats-new/drips/modal-notification-drips.component';
import { ModalNotificationOfiRegisteredAccountsComponent } from './whats-new/ofi-registered-accounts/modal-notification-ofi-registered-accounts.component';
import { ModalNotificationNotificationHubComponent } from './whats-new/notification-hub/modal-notification-notification-hub.component';
import { ModalNotificationOfiOpenBankingComponent } from './whats-new/ofi-open-banking/modal-notification-ofi-open-banking.component';
import { ModalNotificationRecurringInvestmentsComponent } from './whats-new/recurring-investments/modal-notification-recurring-investments.component';

@Component({
  selector: 'td-wb-modal-notification-content',
  template: ''
})
export class ModalNotificationContentComponent {
  readonly triggerId = input<string>();

  private static readonly MODAL_MAP =
    new Map<ModalIdWB, Type<unknown>>([
      [ ModalIdWB.FRACTIONAL_TRADING, ModalNotificationFractionalTradingComponent ],
      [ ModalIdWB.RECURRING_TRANSFERS, ModalNotificationRecurringTransfersComponent ],
      [ ModalIdWB.FHSA_ACCOUNT, ModalNotificationFhsaAccountComponent ],
      [ ModalIdWB.FHSA_RECURRING, ModalNotificationFhsaRecurringComponent ],
      [ ModalIdWB.TRANSACTION_HISTORY, ModalNotificationTransactionHistoryComponent ],
      [ ModalIdWB.FULLY_PAID_LENDING, ModalNotificationFullyPaidLendingComponent ],
      [ ModalIdWB.DRIPS, ModalNotificationDripsComponent ],
      [ ModalIdWB.OFI_REGISTERED_ACCOUNTS, ModalNotificationOfiRegisteredAccountsComponent ],
      [ ModalIdWB.NOTIFICATION_HUB, ModalNotificationNotificationHubComponent ],
      [ ModalIdWB.OFI_OPEN_BANKING, ModalNotificationOfiOpenBankingComponent ],
      [ ModalIdWB.RECURRING_INVESTMENTS, ModalNotificationRecurringInvestmentsComponent ]
    ]);

  private readonly viewContainerRef = inject(ViewContainerRef);

  constructor() {
    effect((): void => {
      const triggerId = this.triggerId();

      this.viewContainerRef.clear();

      const modalType = triggerId
        ? ModalNotificationContentComponent.MODAL_MAP.get(triggerId as ModalIdWB)
        : undefined;

      if (modalType !== undefined) {
        this.viewContainerRef.createComponent(modalType);
      }
    });
  }
}
